import { render, staticRenderFns } from "./PostView.vue?vue&type=template&id=2cf1e3aa&scoped=true&"
import script from "./PostView.vue?vue&type=script&lang=js&"
export * from "./PostView.vue?vue&type=script&lang=js&"
import style0 from "./PostView.vue?vue&type=style&index=0&id=2cf1e3aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf1e3aa",
  null
  
)

export default component.exports